import React from "react";

import { Card, Description, Title } from "./styles";

interface UpcomingStepCardProps {
    title: string;
    description: string;
}

export const UpcomingStepCard = ({ title, description }: UpcomingStepCardProps) => (
    <Card>
        <Title>{title}</Title>
        <Description>{description}</Description>
    </Card>
);
